import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import SchemesCategoriesDetail from './components/SchemesCategoriesDetail.vue';
let default_1 = class extends Vue {};
default_1 = __decorate([Component({
  name: 'ManageSchemesCategories',
  components: {
    SchemesCategoriesDetail
  },
  props: ['isEdit']
})], default_1);
export default default_1;